import { wrapperBuilder } from './build';
wrapperBuilder
  .getVariablesRegisterInstance()
  .addVariable('rules', { startValue: undefined });
